import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, Table, TableHead, TableCell, TableBody, TableRow, ButtonBase, } from '@material-ui/core';
import MTabsButton from '../../view/MTabsButton';
import MDivider from '../../view/MDivider';
import Apis from '../../../network/Apis';
import MTabPanel from '../../view/MTabPanel';
import MovieStateBasketStatistics from './MovieStateBasketStatistics';
import MovieStateBasketTextLive from './MovieStateBasketTextLive';

class MovieStateBasket extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            value: 0,
            matchData: null,
        };
        console.log('MovieStateBasket', props);
    }

    componentDidMount() {
        this.getBasketballRealtimeData();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getBasketballRealtimeData = async () => {
        let { matchId, matchType } = this.props.match.params;
        const { data } = this.props;
        if (matchType == 0) {
            matchType = data.match_type;
        }
        if (matchId == 0) {
            matchId = data.match_id;
        }

        let result = await Apis.encryptionDetailLive(matchType, matchId);
        console.log('getBasketballRealtimeData', result);
        if (result.code == 200) {
            this.setState({ matchData: result.data })
        }
    }

    _handleChange = (value) => {
        this.setState({ value: value });
    }

    renderAbstract = () => {
        const { classes, data } = this.props;
        const { matchData } = this.state;
        let home_score = matchData && matchData.score ? matchData.score[3] : [];
        let allHomeScore = 0;
        if (home_score) {
            for (let i = 0; i < home_score.length; i++) {
                allHomeScore += home_score[i];
            }
        }

        let away_score = matchData && matchData.score ? matchData.score[4] : [];
        let allAwayScore = 0;
        if (away_score) {
            for (let i = 0; i < away_score.length; i++) {
                allAwayScore += away_score[i];
            }
        }

        return (
            <Table style={{ width: '100vw' }}>
                <TableHead style={{ width: '100vw' }}>
                    <TableRow>
                        <TableCell align='left' className={classes.tableHead}><Typography style={{ color: '#898989', fontSize: 9, marginLeft: 8 }}>球队</Typography></TableCell>
                        <TableCell align='center' className={classes.tableHead}>Q1</TableCell>
                        <TableCell align='center' className={classes.tableHead}>Q2</TableCell>
                        <TableCell align='center' className={classes.tableHead}>Q3</TableCell>
                        <TableCell align='center' className={classes.tableHead}>Q4</TableCell>
                        <TableCell align='center' className={classes.tableHead}>QT</TableCell>
                        <TableCell align='center' className={classes.tableHead}>总分</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ width: '100vw' }}>
                    <TableRow style={{ height: 24 }}>
                        <TableCell align='center' className={classes.tableBody}>
                            <Grid container direction='row' alignItems='center'>
                                <MDivider width={3} height={9} backgroundColor='#FC2E34' borderRadius={1.5} marginH={4} />
                                <Typography className={classes.tableBody}>{data ? data.home_name : ''}</Typography>
                            </Grid>
                        </TableCell>
                        <TableCell align='center' className={classes.tableBody}>{home_score ? home_score[0] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{home_score ? home_score[1] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{home_score ? home_score[2] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{home_score ? home_score[3] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{home_score ? home_score[4] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{allHomeScore}</TableCell>
                    </TableRow>
                    <TableRow style={{ height: 24 }}>
                        <TableCell align='left' className={classes.tableBody}>
                            <Grid container direction='row' alignItems='center'>
                                <MDivider width={3} height={9} backgroundColor='#368CF4' borderRadius={1.5} marginH={4} />
                                <Typography style={{ fontSize: 9, color: '#0D0D0D' }}>{data ? data.away_name : ''}</Typography>
                            </Grid>
                        </TableCell>
                        <TableCell align='center' className={classes.tableBody}>{away_score ? away_score[0] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{away_score ? away_score[1] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{away_score ? away_score[2] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{away_score ? away_score[3] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{away_score ? away_score[4] : ''}</TableCell>
                        <TableCell align='center' className={classes.tableBody}>{allAwayScore}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    render() {
        const { classes, data } = this.props;
        const { value } = this.state;
        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <Grid style={{ width: '100%', backgroundColor: '#FFF' }}>
                    {
                        this.renderAbstract()
                    }
                </Grid>
                <Grid container direction='row' alignItems='center' justify='center' style={{ paddingTop: 16, paddingBottom: 16 }} >
                    <MTabsButton data={['文字直播', '技术统计']} onChange={(value) => this._handleChange(value)} />
                </Grid>
                <Grid style={{ width: '100%', backgroundColor: '#FFF' }}>
                    <MTabPanel value={value} index='0' style={{ width: '100%' }}>
                        <MovieStateBasketTextLive data={data} />
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100%' }}>
                        <MovieStateBasketStatistics data={data} />
                    </MTabPanel>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        borderRadius: 10,
        backgroundColor: '#F5F5F5'
    },
    tableHead: {
        fontSize: 7,
        color: '#898989',
        height: 36,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        border: 0,
    },
    tableBody: {
        fontSize: 9,
        color: '#0D0D0D',
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
        border: 0,
    },
    button: {
        backgroundColor: ''
    }

}))(MovieStateBasket));